import styled, { keyframes } from 'styled-components'
import colorsOptions from '../../fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../fundamentals/text-styles/constants'
import { snackbarStyleVariantOptions } from './constants'

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`

const slideOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
`

const SnackbarContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.5rem;

  border-radius: 16px;
  background-color: ${(props) =>
    props.snackbarType
      ? snackbarStyleVariantOptions[props.snackbarType]?.backgroundColor
      : colorsOptions.greys['grey-10']};

  min-width: 240px;
  width: fit-content;
  max-width: 300px;
  box-shadow: -4px 8px 24px 0px #141a2129;
  box-sizing: border-box;
  animation: ${({ animation }) => (animation === 'showIn' ? slideIn : slideOut)}
    0.3s ease-in-out forwards;
`

const SnackbarLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin: 0.25rem;
`

const SnackbarMiddle = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border-right: ${({ snackbarType, hideCloseButton }) =>
    hideCloseButton
      ? 'none'
      : `1px solid ${
          snackbarType
            ? snackbarStyleVariantOptions[snackbarType]?.color
            : colorsOptions.greys['grey-100']
        }`};

  gap: 1rem;
  padding: 0 0.5rem;
`

const SnackbarMessage = styled.div`
  color: ${(props) =>
    props.snackbarType
      ? snackbarStyleVariantOptions[props.snackbarType]?.color
      : colorsOptions.greys['grey-100']};

  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  flex: 1 1 auto;
  padding: 0.5rem 0;
`

const SnackbarButtonAction = styled.div`
  white-space: nowrap;
  order: 1;
  margin-left: auto;
`

const SnackbarRight = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  cursor: pointer;
`

const SnackbarListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  z-index: 1000;
  position: fixed;
  top: 5rem;
  right: 2rem;

  align-items: flex-end;
`

export {
  SnackbarContainer,
  SnackbarLeft,
  SnackbarMiddle,
  SnackbarMessage,
  SnackbarButtonAction,
  SnackbarRight,
  SnackbarListWrapper
}
